import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Language, Model as SettingsModel } from 'models/settings';
import { Version as OnboardingVersion } from 'models/user/onboarding';

import * as actions from './actions';

type Settings = Omit<SettingsModel, '_id'> & {
  lang: Language;
  isBusy: boolean;
};

const initialState: Settings = {
  lang: 'en',
  texts: {},
  onboardingVersion: OnboardingVersion.SHORTENED,
  isBusy: false,
};

export const settings = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    init: (state, action: PayloadAction<actions.Init>) => {
      state.lang = action.payload.lang;
      state.texts = action.payload.texts;
      state.onboardingVersion = action.payload.onboardingVersion;
    },
    setLang: (state, action: PayloadAction<Language>) => {
      state.lang = action.payload;
    },
  },
});

export const { init, setLang } = settings.actions;
export default settings.reducer;
